module.exports = __webpack_public_path__ + "static/people-06960501ac15d46c0077e30e37fa6174.png";